export enum BulkCompanyChangeOfficerAppointStepsEnum {
  FormDescription = 0,
  AppointOfficer = 1,
  Summary = 2,
}
